import React, { useCallback, useState } from 'react';

import { Box, Collapse, Typography } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import PushNotificationCard from '../PushNotificationCard';

import {
  chevronIconExpandedStyles,
  chevronIconStyles,
  groupCountBadgeStyles,
  groupHeaderLeftStyles,
  groupHeaderStyles,
} from './PushNotificationGroup.styles';
import { PushNotificationGroupTestIds } from './PushNotificationGroup.testIds';

const PushNotificationGroup = ({ group, onCardClick, onClose, onToggleImportant }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { items, groupId } = group;
  const isSingleItem = items.length === 1;

  const onToggle = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  if (isSingleItem) {
    return (
      <PushNotificationCard
        notification={items[0]}
        onCardClick={onCardClick}
        onClose={onClose}
        onToggleImportant={onToggleImportant}
      />
    );
  }

  return (
    <Box>
      <PushNotificationCard
        notification={items[0]}
        onCardClick={onCardClick}
        onClose={onClose}
        onToggleImportant={onToggleImportant}
      />

      <Box
        data-testid={PushNotificationGroupTestIds.getToggleId(groupId)}
        sx={groupHeaderStyles}
        onClick={onToggle}
      >
        <Box sx={groupHeaderLeftStyles}>
          <Box sx={isExpanded ? chevronIconExpandedStyles : chevronIconStyles}>
            <ArrowCheckIcon direction={IconDirection.DOWN} />
          </Box>

          <Typography variant="medium12">
            {isExpanded ? 'Hide' : 'Show'} {items.length - 1} more
          </Typography>
        </Box>

        <Typography sx={groupCountBadgeStyles} variant="medium12">
          {items.length}
        </Typography>
      </Box>

      <Collapse in={isExpanded} timeout="auto">
        {items.slice(1).map(notification => (
          <PushNotificationCard
            key={notification.id}
            notification={notification}
            onCardClick={onCardClick}
            onClose={onClose}
            onToggleImportant={onToggleImportant}
          />
        ))}
      </Collapse>
    </Box>
  );
};

PushNotificationGroup.propTypes = {
  group: PropTypes.shape({
    groupId: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }),
    ).isRequired,
    groupKey: PropTypes.string,
  }).isRequired,
  onCardClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onToggleImportant: PropTypes.func.isRequired,
};

export default PushNotificationGroup;
